import { render, staticRenderFns } from "./ProjectDimensions.vue?vue&type=template&id=0eb9bc0c&"
import script from "./ProjectDimensions.vue?vue&type=script&lang=js&"
export * from "./ProjectDimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports